import { CaretUp, LockKey } from '@phosphor-icons/react';
import { useState } from 'react';

const SecurityTag = () => {
	const [showTooltip, setShowTooltip] = useState(false);

	return (
		<span
			className='group flex items-center gap-1 text-xs bg-h-primary-90/50 text-h-primary rounded-full px-2 py-1 font-medium w-fit relative transition-all duration-300'
			onMouseEnter={() => setShowTooltip(true)}
			onMouseLeave={() => setShowTooltip(false)}
		>
			Encriptado
			<LockKey
				weight='fill'
				size={14}
			/>
			{showTooltip && (
				<div className='absolute top-6 left-1/2 -translate-x-1/2 z-20'>
					<div className='flex items-center flex-col w-[280px] '>
						<CaretUp
							weight='fill'
							size={28}
							className='text-h-primary-90 -mb-2.5'
						/>
						<div className='bg-h-primary-90 w-full rounded-lg p-4 flex flex-col gap-3 text-h-primary font-normal'>
							<p>
								Tenemos protegidas tus credenciales y las de más de{' '}
								<b>135,000 personas</b> por métodos de cifrado de última
								generación.
							</p>
						</div>
					</div>
				</div>
			)}
		</span>
	);
};

export default SecurityTag;
